// src/StreakComponent.js
// AUTH-1c/1d: two conditional blocks (sign-in + invite).
// CFG-STREAK-WEB-1: the fire schedule and the invite cooldown come from `streak` in /config
// (`streak.milestones` / `streak.repeatEveryVotes` / `streak.inviteSuppressionDays`) — never from a literal here.
import React, { useState, useEffect } from 'react';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { app } from './firebaseConfig';
import { useNavigate } from 'react-router';
import InviteFriends from './InviteFriends';
import { STORAGE_KEYS } from './v2Api';
import { inviteCooldownActive } from './streakLogic';
export { streakScheduleFires, streakInterruptFires } from './streakLogic';

const StreakComponent = ({ user, onSignInTapped, streakConfig }) => {
  const [inGroupWithOthers, setInGroupWithOthers] = useState(false);
  const [voteCount, setVoteCount] = useState(0);
  const navigate = useNavigate();
  const db = getFirestore(app);

  const isSignedIn = !!(user && !user.isAnonymous);
  const showSignInBlock = !isSignedIn;
  const showInviteBlock = !inGroupWithOthers && !inviteCooldownActive(streakConfig);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.voteCount);
    if (stored) setVoteCount(parseInt(stored, 10));

    const checkGroup = async () => {
      if (!user) return;
      try {
        const snap = await getDocs(
          query(collection(db, 'groups_v2_users'), where('user_id', '==', user.uid))
        );
        if (snap.docs.length > 0) {
          const groupIds = snap.docs.map(d => d.data().group_id);
          const gSnap = await getDocs(
            query(collection(db, 'groups'), where('__name__', 'in', groupIds))
          );
          const hasFriends = gSnap.docs.some(d => (d.data().member_count || 0) > 1);
          setInGroupWithOthers(hasFriends);
        }
      } catch (e) {
        console.error('StreakComponent: group check error', e);
      }
    };
    checkGroup();
  }, [user, db]);

  // Skip streak page if neither block has anything to show.
  useEffect(() => {
    if (!showSignInBlock && !showInviteBlock) {
      navigate('/options');
    }
  }, [showSignInBlock, showInviteBlock, navigate]);

  const handleInviteTapped = () => {
    localStorage.setItem(STORAGE_KEYS.streakLastInviteAt, new Date().toISOString());
  };

  return (
    <div className="StreakComponent">
      <h1>{voteCount} events reviewed!</h1>

      {showSignInBlock && (
        <div className="streak-block">
          <p>Save your picks. Verify your email once to restore your selection on any device.</p>
          <button
            className="active-button"
            onClick={onSignInTapped}
            data-testid="streak-sign-in-button"
          >
            Sign in to save your picks
          </button>
        </div>
      )}

      {showInviteBlock && (
        <div className="streak-block">
          <p>Invite friends to share picks — what excites them boosts your scores when you navigate at the burn.</p>
          <InviteFriends user={user} active={true} onInviteTapped={handleInviteTapped} />
        </div>
      )}

      <button className="secondary-button" onClick={() => navigate('/options')}>Continue exploring</button>
    </div>
  );
};

export default StreakComponent;
